import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {SharedModule} from '@modules/shared/shared.module';
import {DashboardRoutingModule} from './dashboard-routing.module';
import {StatisticCardComponent} from './statistic-card/statistic-card.component';
import {StatisticTableComponent} from './statistic-table/statistic-table.component';
import {MaterialModule} from '../material/material.module';
import {DashboardComponent} from './dashboard/dashboard.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    SharedModule,
    DashboardRoutingModule,
    MaterialModule,
  ],
  declarations: [
    StatisticCardComponent,
    StatisticTableComponent,
    DashboardComponent,
  ],
  exports: [
    DashboardComponent,
  ]
})
export class DashboardModule { }



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/dashboard.module.ts